export type RcSetupStep = {
  number: number
  label: string
  isActive: boolean
  isCompleted: boolean
}

const RC_STEP_LABELS = {
  1: 'rc_setup_stepper_eligibility',
  2: 'rc_setup_stepper_commission',
  3: 'rc_setup_stepper_billing',
  4: 'rc_rate_check_stepper',
} as const

export type RcSetupStepKey = keyof typeof RC_STEP_LABELS

export function getRcSetupSteps(activeStep: RcSetupStepKey): RcSetupStep[] {
  return Object.entries(RC_STEP_LABELS).map(([numberStr, label]) => {
    const number = Number(numberStr)
    return {
      number,
      label,
      isActive: number === activeStep,
      isCompleted: number < activeStep,
    }
  })
}
